import { httpClient } from './httpClient';

export const sendContactMessage = async (payload) => {
  const response = await httpClient.post('/api/Message/ContactUs', {
    title: payload?.title ?? '',
    fullName: payload?.fullName ?? '',
    email: payload?.email ?? '',
    mobile: payload?.mobile ?? '',
    note: payload?.note ?? '',
  });

  return response?.data ?? {};
};
